module.exports = __webpack_public_path__ + "static/img/future_music_logo.53e0519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-mini-guitar/future_music_logo.png
// module id = 1ASL
// module chunks = 13